module.exports = __webpack_public_path__ + "img/undraw_winners_ao2o 1.c7b391e7.png";